export type AnalyticsPayload = Record<string, unknown>;
export type DataLayerEvent = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

function normalizePayload(payload: AnalyticsPayload = {}): DataLayerEvent {
  return Object.entries(payload).reduce<DataLayerEvent>((acc, [key, value]) => {
    acc[key.toLowerCase()] = value ?? null;
    return acc;
  }, {});
}

export function ensureDataLayer(): DataLayerEvent[] {
  if (typeof window === "undefined") return [];
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

export function trackEvent(
  eventName: string,
  payload: AnalyticsPayload = {},
): void {
  if (typeof window === "undefined") return;

  const dataLayer = ensureDataLayer();

  dataLayer.push({
    event_data: null,
  });

  dataLayer.push({
    event: eventName,
    ...normalizePayload(payload),
  });
}
